exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style-module__popup___1kWoF{position:fixed;z-index:1200;top:0;left:0;width:100vw;height:100vh;align-items:center;justify-content:center;display:flex;background-color:rgba(0,0,0,0.5)}\n", ""]);

// exports
exports.locals = {
	"popup": "style-module__popup___1kWoF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/PopupLoader/style.module.scss
// module id = 1513
// module chunks = 0